import { useDispatch, useSelector } from "react-redux";
import { Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import moment from "moment";

import { palette } from "../../../theme/palette";

import { hasForceUnlockMatrixRoleSelector } from "../../../reducers/ownUser/selectors";
import { depotLockSelector } from "../../../reducers/depot/selectors";
import {
  driverEditSelector,
  isDriverEditProfileValidSelector,
  isDriverEditWorkScheduleValidSelector,
  anyDriverDayLockedSelector,
  anyRouteDayLockedSelector,
  driverEditCopySelector,
  selectingDriverLocationSelector,
} from "../../../reducers/driverManagement/selectors";
import {
  resetDriver,
  saveChanges,
  unlockDepotWeek,
} from "../../../reducers/driverManagement/thunkActions";
import {
  setUnlockDriversWeekModalOpen,
  setUnlockMatrixWeekModalOpen,
} from "../../../reducers/ownApp";

import { UnlockIcon } from "../../Icons";
import { View } from "../../View";
import { ActionButton } from "../Common/ActionButton";
import { CancelSaveActionButtons } from "../Common/CancelSaveActionButtons";

const useStyles = makeStyles(({ typography }) => ({
  lockedByText: {
    color: palette.typography.white.solid,
    display: "inline",
    fontSize: "12px",
    marginRight: "10px",
  },
  lockedDatetime: {
    color: palette.typography.white.inactive,
    display: "inline",
    fontSize: "12px",
    marginRight: "10px",
  },
  unlockIcon: {
    color: palette.typography.black.solid,
    width: "10px",
    height: "12px",
    marginRight: "3px",
  },
}));

const LockComponent = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const hasForceUnlockMatrixRole = useSelector(
    hasForceUnlockMatrixRoleSelector
  );
  const depotLock = useSelector(depotLockSelector);
  const driverEdit = useSelector(driverEditSelector);
  const driverChanged = driverEdit !== useSelector(driverEditCopySelector);
  const selectingDriverLocation = useSelector(selectingDriverLocationSelector);
  const isDriverEditProfileValid = useSelector(
    isDriverEditProfileValidSelector
  );
  const isDriverEditWorkScheduleValid = useSelector(
    isDriverEditWorkScheduleValidSelector
  );
  const anyDriverDayLocked = useSelector(anyDriverDayLockedSelector);
  const anyRouteDayLocked = useSelector(anyRouteDayLockedSelector);

  const shouldDisableCancel = () => selectingDriverLocation;
  const shouldDisableSave = () =>
    !driverEdit ||
    !driverChanged ||
    !isDriverEditProfileValid ||
    !isDriverEditWorkScheduleValid ||
    selectingDriverLocation;

  const showForceUnlockMatrix =
    !depotLock.lockedByUserCode &&
    hasForceUnlockMatrixRole &&
    (anyDriverDayLocked || anyRouteDayLocked);

  return (
    <View>
      <View>
        {depotLock.lockedByUserCode && (
          <Typography className={classes.lockedByText}>
            {depotLock.lockedByText}
          </Typography>
        )}

        {depotLock.lockedDatetime && (
          <Typography className={classes.lockedDatetime}>
            {moment(depotLock.lockedDatetime).format("HH:mm DD/MM/YY")}
          </Typography>
        )}

        {driverEdit && (
          <CancelSaveActionButtons
            onCancelClick={async () => {
              if (driverChanged) await dispatch(unlockDepotWeek());
              dispatch(resetDriver());
            }}
            onSaveClick={() => {
              if (driverChanged) dispatch(saveChanges());
              else dispatch(resetDriver());
            }}
            cancelDisabled={shouldDisableCancel()}
            saveDisabled={shouldDisableSave()}
          />
        )}
        {showForceUnlockMatrix && (
          <ActionButton
            variant={"yellow"}
            onClick={() => {
              dispatch(setUnlockMatrixWeekModalOpen(true));
            }}
          >
            <UnlockIcon className={classes.unlockIcon} />
            Unlock Matrix Week
          </ActionButton>
        )}
        {!showForceUnlockMatrix && anyDriverDayLocked && (
          <ActionButton
            variant={"yellow"}
            onClick={() => {
              dispatch(setUnlockDriversWeekModalOpen(true));
            }}
          >
            <UnlockIcon className={classes.unlockIcon} />
            Unlock Drivers Week
          </ActionButton>
        )}
      </View>
    </View>
  );
};

export default LockComponent;
